import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import Backend from "i18next-http-backend"
import { getAppLanguage } from "hooks/useLanguage"

const lang = getAppLanguage()

// Add event listeners for debugging (only in development)
if (process.env.NODE_ENV === "development") {
  i18n.on("initialized", options => {
    console.log("i18n initialized with options:", options)
  })

  i18n.on("loaded", loaded => {
    console.log("i18n loaded:", loaded)
  })

  i18n.on("languageChanged", lng => {
    console.log("i18n language changed to:", lng)
  })
}

i18n
  .use(Backend)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: process.env.NODE_ENV === "development",
    fallbackLng: lang.key || "ar",
    lng: lang.key || "ar", // Set language explicitly, no detection
    ns: ["translation"],
    defaultNS: "translation",
    preload: ["en", "ar"], // Preload both English and Arabic
    load: "currentOnly", // Load current language first, then preload others
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
      requestOptions: {
        cache: "force-cache", // Cache aggressively
        headers: {
          "Cache-Control": "public, max-age=31536000", // Cache for 1 year
        },
      },
      allowMultiLoading: false, // Load one file at a time
      crossDomain: false, // Disable if not needed
      withCredentials: false, // Disable if not needed
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    react: {
      useSuspense: false, // Disable Suspense to show keys while loading
      bindI18n: "languageChanged",
      bindI18nStore: "added",
      transEmptyNodeValue: "", // Return empty string for empty nodes
      transSupportBasicHtmlNodes: true, // Allow basic HTML nodes in translations
      transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"], // Keep these HTML nodes
      transWrapTextNodes: "", // Don't wrap text nodes
    },
    // Add retry options
    retry: {
      retries: 1, // Instead of 3 - faster failure
      backoff: {
        min: 100, // Instead of 1000ms
        max: 1000, // Instead of 5000ms
      },
    },
    // Add missing translation handling
    // saveMissing: true,
    // missingKeyHandler: (lng, ns, key) => {
    //   console.warn(`Missing translation key: ${key} for language: ${lng}`)
    //   return key // Return the key as fallback
    // },
    partialBundledLanguages: true, // Bundle partial translations
  })

export default i18n
